import { render, staticRenderFns } from "./allgoodrecycle.vue?vue&type=template&id=73c07efe&scoped=true"
import script from "./allgoodrecycle.vue?vue&type=script&lang=js"
export * from "./allgoodrecycle.vue?vue&type=script&lang=js"
import style0 from "./allgoodrecycle.vue?vue&type=style&index=0&id=73c07efe&prod&lang=scss&scoped=true"
import style1 from "./allgoodrecycle.vue?vue&type=style&index=1&id=73c07efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c07efe",
  null
  
)

export default component.exports